import React from 'react';

/**
 * 播放图标 - 圆形背景带播放三角形
 * 用于视频或音频播放按钮
 */
const PlayIcon = ({ style, className }) => {
    return (
        <svg 
            viewBox="0 0 1024 1024" 
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="currentColor"
            style={{ 
                display: 'inline-block', 
                verticalAlign: 'middle',
                ...style 
            }}
            className={className}
        >
            <path d="M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z" fill="currentColor" />
            <path d="M712.977067 542.993067l-252.7232 174.011733a34.133333 34.133333 0 0 1-53.521067-28.125867V340.855467a34.133333 34.133333 0 0 1 53.521067-28.125867l252.7232 174.08a34.133333 34.133333 0 0 1 0 56.183467z" fill="#ffffff" />
        </svg>
    );
};

export default PlayIcon;

